import { Button, Tooltip } from 'antd';
import {
  PlayCircleOutlined,
  StopOutlined,
  ReloadOutlined,
} from '@ant-design/icons';
import { useDebounceFn } from 'ahooks';

type IndexProps = {
  status: string;
  xiaohongshuNo: string;
  xiaohongshuName: string;
  buttonClick: (
    action: string,
    xiaohongshuNo: string,
    xiaohongshuName: string,
  ) => void;
};

const Index: React.FC<IndexProps> = ({
  status,
  xiaohongshuNo,
  xiaohongshuName,
  buttonClick,
}) => {
  const { run: onClick } = useDebounceFn(
    (action: string) => {
      buttonClick(action, xiaohongshuNo, xiaohongshuName);
    },
    { wait: 200 },
  );

  const startButton = () => {
    return (
      <Tooltip title="启动">
        <Button onClick={() => onClick('start')}>
          <PlayCircleOutlined />
        </Button>
      </Tooltip>
    );
  };

  const stopButton = () => {
    return (
      <Tooltip title="停止">
        <Button onClick={() => onClick('stop')}>
          <StopOutlined />
        </Button>
      </Tooltip>
    );
  };

  const restartButton = () => {
    return (
      <Tooltip title="重启">
        <Button onClick={() => onClick('restart')}>
          <ReloadOutlined />
        </Button>
      </Tooltip>
    );
  };

  return (
    <>
      {status === 'stopped' && startButton()}
      {status === 'error' && restartButton()}
      {status === 'running' && (
        <>
          {stopButton()}
          {restartButton()}
        </>
      )}
    </>
  );
};

export default Index;
